<template>
  <div>
    <title1 type="1" title="总有功/无功功率监控" />
    <div style="width: 560px; height: 300px">
      <MyEcharts
        v-if="showcdata"
        :id="'options24h44ours332321332e4333warn1122'"
        :options="cdata"
      />
    </div>
  </div>
</template>

<script>
import MyEcharts from "@/views/exposition/components/charts/echarts.vue";
import * as echarts from "echarts5";
import title1 from "@/views/exposition/components/title1";
import { dataInterface } from "@/api/dataInterfaceApi";
export default {
  components: {
    MyEcharts,
    title1,
  },
  data() {
    return {
      showcdata: false,
      // title:"车辆新增及活跃趋势",
      cdata: {
        tooltip: {
          trigger: "axis",
          show: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
        },
        yAxis: {
          name: "kW",
          type: "value",
          splitLine: false,
        },
        series: [
          {
            name: "充电功率",
            type: "line",
            smooth: true,
            data: [],
            tooltip: {
              valueFormatter: function (value) {
                return value + " kWh";
              },
            },
            itemStyle: {
              color: "#C4AF46",
            },
            lineStyle: {
              color: "#C4AF46",
            },
            areaStyle: {
              width: 2,
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                {
                  offset: 0.1,
                  color: "#C4AF46",
                },
                {
                  offset: 0.9,
                  color: "#C4AF46",
                },
              ]),
            },
          },
          {
            name: "放电功率",
            type: "line",
            smooth: true,
            tooltip: {
              valueFormatter: function (value) {
                return value + " kWh";
              },
            },
            itemStyle: {
              color: "#59A8A9",
            },
            lineStyle: {
              color: "#59A8A9",
            },
            areaStyle: {
              width: 2,
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                {
                  offset: 0.1,
                  color: "#59A8A9",
                },
                {
                  offset: 0.9,
                  color: "#59A8A9",
                },
              ]),
            },
          },
        ],
      },
    };
  },
  destroyed() {
    this.$bus.$off('bigScreen::storedEnergyId')
  },
  mounted() {
    this.$bus.$on("bigScreen::storedEnergyId", () => {
      this.getzhandianyongdianliang();
    });
    this.getzhandianyongdianliang();
  },
  methods: {
    //获取电港用电量
    getzhandianyongdianliang() {
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const day = now.getDate().toString().padStart(2, "0");
      const timer = `${year}-${month}-${day}`;
      let params = {
        enCode: "chuneng-quanguo-yggljk",
        "@energyId": localStorage.getItem('bigScreen::storedEnergyId') || "ES00001",
        // "@dim_date": "2023-10-16",
        '@dim_date': timer
      };
      this.showcdata = false;
      dataInterface.dataFaceApi(params).then((res) => {
          // console.log(res, "999999900000");
          if (res) {
            let data = [];
            let data2 = [];
            let xAxis = [];
            res.forEach((item) => {
              xAxis.push(item.cur_hour);
              data.push(item.charge_power);
              data2.push(item.discharge_power);
            });
            this.cdata.xAxis.data = xAxis;
            this.cdata.series[0].data = data;
            this.cdata.series[1].data = data2;
            this.showcdata = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scope>
.main-box-diangganggaikuang {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .main-box-cell {
    margin-bottom: 6px;
    display: flex;
    width: 200px;
    height: 100px;
    padding: 0 10px;

    .main-box-left {
      img {
        width: 80px;
        height: 80px;
      }
    }

    .main-box-right {
      padding-left: 15px;

      .top {
        height: 50px;
        line-height: 70px;
      }

      .bottom {
        height: 50px;
        font-size: 22px;
        line-height: 30px;
      }
    }
  }
}
</style>
